import { render, staticRenderFns } from "./ausers.vue?vue&type=template&id=48599c7a&"
import script from "./ausers.vue?vue&type=script&lang=js&"
export * from "./ausers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports